/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EvaluationCommentWithRelations } from './evaluationCommentWithRelations';
import { StatusWithRelations } from './statusWithRelations';
import { EvaluationPeriodWithRelations } from './evaluationPeriodWithRelations';
import { EvaluationScoresWithRelations } from './evaluationScoresWithRelations';
import { UserWithRelations } from './userWithRelations';
import { SurveysWithRelations } from './surveysWithRelations';


/**
 * (tsType: EvaluationsWithRelations, schemaOptions: { includeRelations: true })
 */
export interface EvaluationsWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    periodId?: string;
    userId: number;
    statusId?: string;
    description?: string;
    evaluationPeriod?: EvaluationPeriodWithRelations;
    user?: UserWithRelations;
    status?: StatusWithRelations;
    surveys?: Array<SurveysWithRelations>;
    evaluationScores?: Array<EvaluationScoresWithRelations>;
    evaluationComments?: Array<EvaluationCommentWithRelations>;
}

